import { render } from "./CardPost.vue?vue&type=template&id=241800e5"
import script from "./CardPost.vue?vue&type=script&lang=js"
export * from "./CardPost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__